import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import ReorderPlaylistModal from 'screens/ReorderPlaylistModal';
import useModalQueryParam from 'hooks/useModalQueryParam';
function ReorderContentButton(_ref) {
  var contentItems = _ref.contentItems,
    playlistId = _ref.playlistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useModalQueryParam = useModalQueryParam('edit-order'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    isReorderContentModalOpen = _useModalQueryParam2[0],
    toggleReorderContentModal = _useModalQueryParam2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "transparent",
    icon: "hierarchy",
    isDisabled: contentItems.length < 2,
    onClick: toggleReorderContentModal
  }, t('actions_reorder_content')), isReorderContentModalOpen && /*#__PURE__*/React.createElement(ReorderPlaylistModal, {
    playlistId: playlistId,
    contentItems: contentItems,
    onClose: toggleReorderContentModal
  }));
}
export default ReorderContentButton;